module.exports = __webpack_public_path__ + "static/media/14UNEP28.03fbc6f9.jpg";